var map = {
	"./cn/b0.png": 603,
	"./cn/b1.png": 604,
	"./cn/b1s.png": 605,
	"./cn/b2.png": 606,
	"./cn/b3.png": 919,
	"./cn/b4.png": 607,
	"./cn/function.png": 920,
	"./cn/function_hk.png": 921,
	"./cn/reward_activities.png": 922,
	"./english/b0.png": 608,
	"./english/b1.png": 609,
	"./english/b2.png": 610,
	"./english/b3.png": 923,
	"./english/b4.png": 611,
	"./english/function.png": 924,
	"./english/function_hk.png": 925,
	"./english/reward_activities.png": 926,
	"./zh/b0.png": 612,
	"./zh/b1.png": 613,
	"./zh/b2.png": 614,
	"./zh/b3.png": 927,
	"./zh/b4.png": 615,
	"./zh/function.png": 928,
	"./zh/function_hk.png": 929,
	"./zh/reward_activities.png": 930
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2597;